<script setup lang="ts">
    const { label = null, icon = null } = defineProps<{
        label?: string;
        icon?: string;
    }>();
</script>

<template>
    <div
        class="badge"
        :class="{ 'icon-only': !label }"
    >
        <span
            v-if="icon"
            class="icon"
        >
            <Icon
                class="badge-icon-svg"
                :name="icon"
                mode="svg"
                size="18px"
            />
        </span>
        <span
            v-if="label"
            class="label"
        >
            {{ label }}
        </span>
    </div>
</template>

<style scoped lang="scss">
    .badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0 $spacing--05;
        border-radius: $border-radius-circle;
        background: $black;
        color: $white;
        gap: $spacing--05;

        &.icon-only {
            width: calc($font-xxs * 2);
            height: calc($font-xxs * 2);
            border-radius: 50%;
            padding: 0;
        }

        span {
            font-size: $font-xxs;
            font-weight: 600;
            line-height: 2;
            white-space: nowrap;
            letter-spacing: 0.02em;
            text-rendering: geometricPrecision;
        }

        .icon {
            width: 1.1rem;
            height: 1.1rem;
            object-fit: contain;

            .iconify {
                color: $white;
            }

            :deep(.badge-icon-svg),
            :deep(.badge-icon-svg *) {
                stroke-width: 2.5;
            }
        }

        .label {
            color: $white;
        }
    }
</style>
